import React from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { alertModal, appUpdateModal } from "../../atomstore/store";
import FootpringSvg from "../../assets/splash-nico-hi.png"

const FootPrintModal = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useAtom(alertModal);
    const [updateModal] = useAtom(appUpdateModal);

    const closeModal = () => {
        setModal(prev => ({ ...prev, state: false }));
    };

    const removeHtmlTags = (message) => {
        if (typeof message === "string") {
            return message.replace(/(<([^>]+)>)/gi, "");
        }
        return message;
    };

    if (updateModal.visible || !modal.state) return null;

    const {
        message,
        isConfirm = false,
        onOkPressed,
        onCancelPressed,
        navigateTo
    } = modal;


    console.log("Modal atom from PastItem:", modal);


    return (
        <div className="fixed inset-0 z-[99999] flex items-end md:items-center justify-center bg-black/40 backdrop-blur-sm p-4">

            {/* Modal Container */}
            <div className="
        w-full md:max-w-md bg-white rounded-2xl shadow-xl 
        animate-[slideUp_0.25s_ease-out] md:animate-[fadeIn_0.25s_ease-out]
        overflow-hidden
      ">

                {/* Header */}
                <div className="flex items-center gap-3 px-5 py-4 border-b">
                    <div className="p-2 rounded-full">
                        <img src={FootpringSvg} className=" size-10 " alt="logo" />

                    </div>
                    <h3 className="font-semibold text-gray-900 text-lg">
                        Parent Connect
                    </h3>
                </div>

                {/* Body */}
                <div className="px-5 py-4">
                    <p className="text-gray-600 text-noramal font-medium leading-relaxed">
                        {removeHtmlTags(message)}
                    </p>
                </div>

                {/* Footer Buttons */}
                <div className="flex  md:flex-row md:justify-end gap-3 px-5 py-4">

                    {/* CANCEL Button – only in confirm mode */}
                    {isConfirm && (
                        <button
                            onClick={() => {
                                onCancelPressed && onCancelPressed();
                                closeModal();
                            }}
                            className="
                w-full md:w-auto px-4 py-2 text-sm font-semibold
                bg-red-500 text-white rounded-lg
                shadow hover:bg-red-600 active:scale-[0.98] transition
              "
                        >
                            Cancel
                        </button>
                    )}

                    {/* OK Button */}
                    <button
                        onClick={() => {
                            // Execute onOkPressed first (if it exists and is a function)
                            if (typeof onOkPressed === "function") {
                                onOkPressed();
                            }
                            // Then navigate if navigateTo is provided
                            // Note: If onOkPressed navigated (e.g., logout), this navigation may not execute
                            if (navigateTo) {
                                navigate(navigateTo);
                            }
                            closeModal();
                        }}
                        className="
              w-full md:w-auto px-4 py-2 text-sm font-semibold
              bg-blue-600 text-white rounded-lg
              shadow hover:bg-blue-700 active:scale-[0.98] transition
            "
                    >
                        OK
                    </button>

                </div>
            </div>

            {/* Animations */}
            <style>{`
        @keyframes slideUp {
          from { transform: translateY(40px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
        </div>
    );
};

export default FootPrintModal;
